<!-- src/views/pages/finance-accounts/sales/taxes-table.vue -->
<script setup>
import { computed } from "vue";
import { useTaxStore } from "@/stores/taxStore";

const emit = defineEmits(["edit", "delete"]);
const store = useTaxStore();

const columns = [
  { sorter: false },
  { title: "Tax Name", dataIndex: "name", key: "name" },
  { title: "Tax Percentage", dataIndex: "ratePretty", key: "ratePretty" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "", key: "action" },
];

const tableData = computed(() =>
  (store.items || []).map((r) => ({
    key: r.id,
    id: r.id,
    name: r.name,
    ratePretty: `${Number(r.rate ?? 0)}%`,
    status: r.status,
    _raw: r,
  }))
);
</script>

<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="tableData"
    :pagination="false"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'name'">
        <div class="d-flex align-items-center">
          <h6 class="fs-14 fw-medium text-gray-9 me-2">{{ record.name }}</h6>
        </div>
      </template>

      <template v-else-if="column.key === 'status'">
        <span
          :class="[
            'badge',
            'badge-xs',
            'd-inline-flex',
            'align-items-center',
            record.status === 'Active' ? 'badge-success' : 'badge-danger',
          ]"
        >
          <i class="ti ti-point-filled me-1"></i>{{ record.status }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a
            href="javascript:void(0);"
            class="me-2"
            @click="emit('edit', record._raw)"
            v-can="'Tax.Edit'"
          >
            <i class="ti ti-edit"></i>
          </a>
          <a href="javascript:void(0);" @click="emit('delete', record._raw)" v-can="'Tax.Delete'">
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>
